<template>
  <v-container>
    <v-card>
      <v-card-title> Seguimiento a Recursos Financieros </v-card-title>
      <v-card-text>
        <div class="Subtitle 1">
          Presupuesto General de la Nación para la implementación del Acuerdo
          Final de Paz
        </div>
        Conozca la ejecución de los recursos del Presupuesto General de la
        Nación destinados a la implementación del Acuerdo, identificados por el
        clasificador presupuestal construcción de paz.
        <br />
        <br />
        <div class="Subtitle 1">Detalle de los recursos de funcionamiento - PGN</div>
        <v-flex row class="container">
          <v-flex xs12 sm6 md3 class="mx-1">
            <v-select
              :items="DataPuntos"
              v-model="puntoselected"
              item-text="nombrepunto"
              item-value="nombrepunto"
              label="Punto del acuerdo"
              sort-by="nombrepunto"
              @change="filterPunto"
            ></v-select>
          </v-flex>
          <v-flex xs12 sm6 md3 class="mx-1">
            <v-select
              :items="DataSector"
              v-model="sectorselected"
              item-text="sector"
              item-value="sector"
              label="Sector"
              @change="filterSector"
            ></v-select>
          </v-flex>
          <v-flex xs12 sm6 md3 class="mx-1">
            <v-select
              :items="DataEntidad"
              v-model="entidadselected"
              item-text="entidad"
              item-value="entidad"
              label="Entidad"
              @change="filterEntidad"
            ></v-select>
          </v-flex>
          <v-flex xs12 sm5 md2 class="mx-1">
            <v-select
              :items="DataVigencia"
              v-model="vigenciaselected"
              item-text="vigencia"
              item-value="vigencia"
              label="Vigencia"
              @change="filterVigencia"
            ></v-select>
          </v-flex>
        </v-flex>
        <v-flex>
          <v-data-table
            :headers="HeaderFuncionamiento"
            :items="DataFuncionamiento"
            
            :custom-filter="customFilter"
            :items-per-page="10"
            class="elevation-1"
            :no-data-text="gnodata"
          >
              <template v-slot:[`item.apropiacionvigente`]="{ item }">
                {{ Intl.NumberFormat("es-CO", { maximumFractionDigits: 0 }).format(item.apropiacionvigente) }}
              </template> 
              <template v-slot:[`item.compromisos`]="{ item }">
                {{ Intl.NumberFormat("es-CO", { maximumFractionDigits: 0 }).format(item.compromisos) }}
              </template>
              <template v-slot:[`item.obligacion`]="{ item }">
                {{ Intl.NumberFormat("es-CO", { maximumFractionDigits: 0 }).format(item.obligacion) }}
              </template>
              <template v-slot:footer>
                  <div id="div1" style="width: 100%; align: right">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <download-excel
                          id="div2"
                          style="width: 100%; text-align: right"
                          v-show="DataFuncionamiento.length > 0"
                          class="btn btn-default"
                          :data="DataFuncionamiento"
                          :fields="exportable"
                          name="seguimiento_funcionamiento.xls"
                          type="xls"
                          worksheet="Información"
                          :title= dataForExcel
                          
                        >
                          <v-icon
                            color="secondary"
                            v-on="on"
                            large
                            elevation="2"
                            >mdi-file-download-outline</v-icon
                          >
                        </download-excel>
                      </template>
                      <span>Descargar</span>
                    </v-tooltip>
                  </div>
              </template>

          </v-data-table>
        </v-flex>
        <v-flex>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from "vuex";

export default {
  name: "recursos_funcionamiento",
  data() {

    return {
      dataForExcel: ["Reporte detallado - Presupuesto General de la Nación - Funcionamiento ( Fuente SPI - Trazador construccion de Paz).", 
      " Para el análisis y uso de la información del trazador revisar documento metodológico en el menú Ayuda de SIIPO 2.0"],
      HeaderFuncionamiento: [
        { text: "Cuenta", value: "nombrecuenta", align: "left" },
        { text: "Punto/Pilar", value: "puntopilar", align: "left" },
        { text: "Apropiación vigente paz", value: "apropiacionvigente", align: "right", },
        {
          text: "Comprometido paz",
          value: "compromisos",
          align: "right",
        },
        { text: "Obligado paz", value: "obligacion", align: "right" },
      ],
      exportable: {
        Vigencia: "vigencia",
        Sector: "sector",
        Entidad: "entidad",
        "Cuenta Programa": "cuentaprograma",
        "Nombre Cuenta": "nombrecuenta",
        Trazador: "trazador",
        Punto: "nombrePunto",
        Pilar: "nombrePilar",
        "Punto/Pilar": "puntopilar",
        "Inicial Política": { 
            field: "apropiacioninicial", 
            callback: (value) => { return ` ${Intl.NumberFormat("es-CO", { maximumFractionDigits: 2 }).format(value)}`; },
                            },
        "Vigente Política":{
            field: "apropiacionvigente", 
            callback: (value) => { return ` ${Intl.NumberFormat("es-CO", { maximumFractionDigits: 2 }).format(value)}`; },
        },
        "Compromisos Política": {
            field: "compromisos", 
            callback: (value) => { return ` ${Intl.NumberFormat("es-CO", { maximumFractionDigits: 2 }).format(value)}`; },
        }, 
        "Obligaciones Política": {
            field: "obligacion", 
            callback: (value) => { return ` ${Intl.NumberFormat("es-CO", { maximumFractionDigits: 2 }).format(value)}`; },
        },        
        "Fecha Corte": "fechacorte"
      },

      recursofuncionamiento: [],

      
      DataFuncionamiento: [],
      DataPuntos: [],
      DataSector: [],
      DataEntidad: [],
      DataVigencia: [],
      puntoselected: "",
      sectorselected: "",
      entidadselected: "",
      vigenciaselected: "",
      filter: "",
      filters: { punto: "", sector: "", entidad: "", vigencia: "" },
    };
  },
  
  methods: {
    ...mapActions([
      "get_recursosfuncionamiento",
    ]),    
    priceFormat(value){
                return '$ ' + value;
            },
    customFilter(items, filters) {
      if (filters.punto != "") {
        if (filters.punto != "TODOS")
          items = items.filter((record) => {
            return record.nombrepunto == filters.punto;
          });
      }
      if (filters.sector != "") {
        if (filters.sector != "TODOS")
          items = items.filter((record) => {
            return record.sector.toLowerCase() == filters.sector.toLowerCase();
          });
      }
      if (filters.entidad != "") {
        if (filters.entidad != "TODAS")
          items = items.filter((record) => {
            return (
              record.entidad.toLowerCase() == filters.entidad.toLowerCase()
            );
          });
      }
      if (filters.vigencia != "") {
        if (filters.vigencia != "TODOS")
          items = items.filter((record) => {
            return record.vigencia == filters.vigencia;
          });
      }

      return items;
    },
    filterPunto(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        punto: val,
      });
      this.DataFuncionamiento = this.customFilter(
        this.recursofuncionamiento,
        this.filters
      );
    },
    filterSector(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        sector: val,
      });
      this.sectorselected = val;
      this.DataFuncionamiento = this.customFilter(
        this.recursofuncionamiento,
        this.filters
      );
      this.filterEntidadSector()
    },
    filterEntidad(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        entidad: val,
      });
      this.DataFuncionamiento = this.customFilter(
        this.recursofuncionamiento,
        this.filters
      );
    },
    filterEntidadSector(){
        this.DataEntidad = [];
        let tmpTodos = Object.assign({}, "");
        tmpTodos.entidad = "TODAS";
        let entidaesfiltradas
        let sectorfilter = this.sectorselected
        if (sectorfilter == "TODOS" || sectorfilter == '' )
        {
          entidaesfiltradas = _.uniqBy(this.recursofuncionamiento, "entidad");

        } else
        {
          entidaesfiltradas = _.uniqBy(this.recursofuncionamiento.filter((record) => {return record.sector == sectorfilter;}), "entidad");
        }
        this.DataEntidad = entidaesfiltradas;
        this.DataEntidad.unshift(tmpTodos);
    },
    filterVigencia(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        vigencia: val,
      });
      this.DataFuncionamiento = this.customFilter(
        this.recursofuncionamiento,
        this.filters
      );
      localStorage.setItem("vigenciaselected", this.vigenciaselected);
    },
    Iniciarelementos(){
      this.DataFuncionamiento = this.recursofuncionamiento.filter(v => v.vigencia <= 2023);

      let tmpTodosPunto = Object.assign({}, "");
      tmpTodosPunto.nombrepunto = "TODOS";
      let puntos = _.uniqBy(this.recursofuncionamiento, "nombrepunto");
      const puntosOrdenados = _.orderBy(puntos, [o => o.puntopilar], ['asc']);
      this.DataPuntos = puntosOrdenados;
      this.DataPuntos.unshift(tmpTodosPunto);

      let tmpTodosSector = Object.assign({}, "");
      tmpTodosSector.sector = "TODOS";
      this.DataSector = _.orderBy(_.uniqBy(this.recursofuncionamiento, "sector"), [o => o.sector], ['asc']);
      this.DataSector.unshift(tmpTodosSector);

      let tmpTodosEntidad = Object.assign({}, "");
      tmpTodosEntidad.entidad = "TODAS";
      this.DataEntidad = _.orderBy(_.uniqBy(this.recursofuncionamiento, "entidad"), [o => o.entidad], ['asc']);
      this.DataEntidad.unshift(tmpTodosEntidad);

      let tmpTodosVigengia = Object.assign({}, "");
      tmpTodosVigengia.vigencia = "TODOS";
      this.DataVigencia = _.uniqBy(this.recursofuncionamiento, "vigencia");
      this.DataVigencia.unshift(tmpTodosVigengia);
    }

  },
  created(){
    this.get_recursosfuncionamiento();
    
  },
  mounted() {
    if (localStorage.vigenciaselected != undefined)
    {
      this.vigenciaselected = localStorage.vigenciaselected
      this.filterVigencia(this.vigenciaselected)
    }
      
  },
  computed: {
    ...mapGetters([
      "rfuncionamiento",
    ]),    
    ...mapGetters("mensaje", ["ginformation", "gnodata", "glogo"]),
  },
  watch: {
    rfuncionamiento: function (newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.recursofuncionamiento = this.rfuncionamiento;
        if (this.recursofuncionamiento.length > 0)
          this.Iniciarelementos();
      }
    }
  }  
};
</script>